(() => {
  "use strict";

  const contextCache = new Map();
  const cacheLifetimeMs = 60_000;
  const requestTimeoutMs = 8_000;

  function fetchItemContext(baseUrl, handle, itemId) {
    const normalizedBaseUrl = normalizeBaseUrl(baseUrl);
    if (!normalizedBaseUrl) {
      return Promise.reject(new Error("Mangler API-adresse for klubbside-kontekst."));
    }

    let grant = "";
    try { grant = window.sessionStorage.getItem(`assistco-club-page-grant-${handle}`) || ""; } catch (_) { /* Storage may be disabled. */ }
    const cacheKey = `${normalizedBaseUrl}|${String(handle || "")}|${String(itemId || "")}|${grant}`;
    const cached = contextCache.get(cacheKey);
    if (cached && cached.expiresAt > Date.now()) {
      return cached.promise;
    }

    const promise = requestItemContext(handle, itemId, grant).catch((error) => {
      contextCache.delete(cacheKey);
      throw error;
    });
    contextCache.set(cacheKey, {
      expiresAt: Date.now() + cacheLifetimeMs,
      promise,
    });
    return promise;
  }

  async function requestItemContext(handle, itemId, grant) {
    const url = new URL("/apps/assistco-club-pages/context", window.location.origin);
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), requestTimeoutMs);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "text/plain;charset=UTF-8",
        },
        body: JSON.stringify({ handle: String(handle || ""), itemId: String(itemId || ""), grant }),
        credentials: "same-origin",
        signal: controller.signal,
      });
      const raw = await response.text();
      let payload;

      try {
        payload = JSON.parse(raw);
      } catch (_error) {
        throw new Error(
          `Klubbside-API svarte ${response.status} uten gyldig JSON.`,
        );
      }

      if (!response.ok || !payload?.ok) {
        throw new Error(payload?.error || "Kunne ikke hente klubbside-kontekst.");
      }

      return payload;
    } catch (error) {
      if (error instanceof DOMException && error.name === "AbortError") {
        throw new Error("Klubbside-API brukte for lang tid på å svare.");
      }
      throw error;
    } finally {
      window.clearTimeout(timeout);
    }
  }

  function normalizeBaseUrl(value) {
    if (!value) {
      return "";
    }

    return String(value).endsWith("/") ? String(value) : `${value}/`;
  }

  function withClubContext(href, productPath, handle, itemId) {
    const url = new URL(href);
    if (url.pathname !== productPath) return href;
    url.searchParams.set("club", handle);
    url.searchParams.set("club_page", handle);
    url.searchParams.set("club_item", itemId);
    return url.href;
  }

  window.AssistCoClubPageApi = Object.freeze({
    fetchItemContext,
    normalizeBaseUrl,
    withClubContext,
  });
})();
